// extracted by mini-css-extract-plugin
export default {"textarea":"TextArea_textarea__CFSWY","label":"TextArea_label__W-z8Q"};